import React, { useState } from "react";
import "./../PG-CSS/paymentGateway.css";
import PaymentComp from "../components/paymentComp";
import { startPaymentSession } from "../actions/paymentGateway";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import WithLayout from "../../trialUsers/container/wrapperLogo";

const StripePaymentCont = (props) => {
   const { subscription_interval } = props;
   const [step, setStep] = useState(2);
   const createStripePayment = () => {
      localStorage.setItem("showTrialButton", "true");
      startPaymentSession(subscription_interval);
   };

   return (
      <WithLayout showNeedHelp={step === 1} removeMargin={true}>
         <PaymentComp createStripePayment={createStripePayment} step={step} setStep={setStep} />
      </WithLayout>
   );
};

const mapStateToProps = (state) => ({
   subscription_interval: state?.auth?.subscriptionInterval,
});

export default withRouter(connect(mapStateToProps)(StripePaymentCont));
